import { VStack } from "native-base";
import React from "react";

import CartFloatingButton from "@/components/atoms/CartFloatingButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import ProductList from "@/components/organisms/ProductList";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import { CategoryProductListScreenProps } from "./types";

const CategoryProductListMobile = ({
  category,
  products,
  isLoading,
  onGoBack,
  onSelectProduct,
  onViewMore,
}: CategoryProductListScreenProps) => {
  const { height } = useViewport();
  const { navigate } = useAppNavigation<HomeNavigation>();

  return (
    <>
      <Container
        px="1"
        pt="2"
        Header={
          <MobileHeader
            title={category?.nome}
            showSearch={true}
            showLogo={false}
            onBackPress={onGoBack}
            onPressSearch={() => navigate("inStoreSearch", { storeId: category?.estabelecimento })}
          />
        }>
        <VStack w="100%" h={height + "px"} mb="32">
          <ProductList
            data={products}
            isLoading={isLoading}
            onLoadMore={onViewMore}
            onSelect={onSelectProduct}
          />
        </VStack>
      </Container>
      <CartFloatingButton />
    </>
  );
};

export default CategoryProductListMobile;
